// The report param a question's list sort is stored under (`s`). Its tokens are one grammar for
// every question type that sorts its items, so a stored value reads the same whichever type wrote
// it; what a type does with a token it does not accept is its own choice, passed in.

export const DEFAULT_SORT_ORDER = 'iasc'

// A built-in order persists as a single letter.
const SORT_PARAM_TO_ORDER = { a: 'vasc', d: 'vdesc', f: 'iasc', b: 'idesc' }
const SORT_ORDER_TO_PARAM = { vasc: 'a', vdesc: 'd', iasc: 'f', idesc: 'b' }

// A table column the researcher sorted by names itself, e.g. "tag_4-desc".
const CUSTOM_SORT_ORDER = /^[a-zA-Z0-9_-]+-(asc|desc)$/

// `custom`: whether the type has columns of its own to sort by. `passUnknown`: a token naming no
// order the type knows reads as undefined, for a caller that tells it apart from the default.
export const decodeSortParam = (
  section,
  { defaultSortOrder = DEFAULT_SORT_ORDER, custom = true, passUnknown = false } = {}
) => {
  const order = undefined === section ? null : String(section).split('!')[0]
  if (!order) return defaultSortOrder

  const known = SORT_PARAM_TO_ORDER[order] || (custom && CUSTOM_SORT_ORDER.test(order) ? order : undefined)

  return known || (passUnknown ? undefined : defaultSortOrder)
}

// The order the list opens on is not stored; nor is a column order, for a type without columns.
export const encodeSortParam = (sortOrder, { defaultSortOrder = DEFAULT_SORT_ORDER, custom = true } = {}) => {
  if (sortOrder === defaultSortOrder) return null

  return SORT_ORDER_TO_PARAM[sortOrder] || (custom ? sortOrder : null)
}

// The stored sort read back for a type with the default order -- the shape every type's report params
// use, so a stored value reads the same whichever type wrote it.
export const resolveSortOrder = (section, defaultSortOrder = DEFAULT_SORT_ORDER) =>
  decodeSortParam(section, { defaultSortOrder })

export const calcSortParamsSection = (sortOrder, defaultSortOrder = DEFAULT_SORT_ORDER) => ({
  s: encodeSortParam(sortOrder, { defaultSortOrder })
})
